import { CoreIcon } from '../core-icon';
import bankJcbSVG from '../../assets/logos/bank-jcb.svg';
import type { IconProps } from '../core-icon';

export const BankJcbIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={bankJcbSVG} {...props} />;
};
